import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import styled from 'styled-components/macro';

import DropDownSelect from '../../DropDownSelect';

import { copyFor } from '../../../copy/copy';
import { requiredFormElements } from '../representatives';

import {
    AnimationContainer,
    Container as BaseContainer,
    Body
} from '../../Shared/PopupModalStyles';

const Container = styled(BaseContainer)`
    top: -50%;
`;

const PrefixPopup = props => (
    <AnimationContainer>
        <Container>
            <Body>
                {copyFor('validationErrors', 'prefixNotAvailable', 'email')}
                <Field
                    name="prefix"
                    type="text"
                    label=""
                    component={DropDownSelect}
                    defaultOption={copyFor('placeholders', 'choose', 'general')}
                    options={props.options}
                    placeholder={props.placeholder}
                    onChange={e => props.updatePrefix(e.target.value)}
                />
            </Body>
        </Container>
    </AnimationContainer>
);

PrefixPopup.propTypes = {
    options: PropTypes.array.isRequired,
    placeholder: PropTypes.string,
    updatePrefix: PropTypes.func.isRequired
};

export default compose(
    connect(state => {
        const elements = requiredFormElements(state);
        const prefixField = elements.find(el => el.name === 'NamePrefix') || {};
        return {
            options: prefixField.options,
            placeholder: prefixField.placeholder,
            initialValues: {
                prefix: ''
            }
        };
    }),
    reduxForm({
        form: 'strictPrefix'
    })
)(PrefixPopup);
